import { fetchAuthSession } from "aws-amplify/auth";
import { getCachedUserAttributes } from "../../shared/utils/utils";

function toBoolean(value, fallback = false) {
  if (typeof value === "boolean") return value;
  if (value == null) return fallback;
  return String(value).toLowerCase() === "true";
}

function buildUserFromTokenPayload(payload, attributes) {
  return {
    id: payload.sub,
    username: payload["cognito:username"],
    email: attributes?.email || payload.email || null,
    emailVerified: toBoolean(
      attributes?.email_verified,
      toBoolean(payload.email_verified)
    ),
    completeProfile: toBoolean(
      attributes?.["custom:complete_profile"],
      toBoolean(payload["custom:complete_profile"])
    ),
    name: payload.name || null,
    picture: payload.picture || null,
  };
}

export async function getAuthSessionUser({ forceRefresh = false } = {}) {
  const session = await fetchAuthSession({ forceRefresh });
  const idToken = session?.tokens?.idToken;

  if (!idToken) return null;

  let attributes = null;

  try {
    attributes = await getCachedUserAttributes();
  } catch {
    attributes = null;
  }

  return buildUserFromTokenPayload(idToken.payload, attributes);
}
